import { RouterProvider, createRouter } from "@tanstack/react-router";
import type { ApolloClient } from "@apollo/client";
import { routeTree } from "./routeTree.gen";
import { ShellHostProvider } from "./shell-handle/ShellHostProvider";
import type { ShellHandleHost } from "./shell-handle/createShellHandle";
import { ToastPortal } from "./presentational/ToastPortal";
import { ErrorBoundary } from "./presentational/ErrorBoundary";

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => null,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export interface AppProps {
  host: ShellHandleHost;
  client: ApolloClient<unknown>;
}

export function App({ host, client }: AppProps) {
  return (
    <ErrorBoundary>
      <ShellHostProvider host={host} client={client}>
        <RouterProvider router={router} />
        <ToastPortal />
      </ShellHostProvider>
    </ErrorBoundary>
  );
}
